/** EdTech partner referral URLs (ADR 017) — honest external redirects via API. */

export const PARTNER_SALES_EMAIL = 'partners@enterweu.com';

export function partnerTutorialGoUrl(tutorialId, source = 'partners_page') {
  const id = Number(tutorialId);
  if (!id) return '';
  const src = ['report', 'partners_page', 'dashboard'].includes(source) ? source : 'partners_page';
  return `/api/partners/tutorials/${id}/go/?source=${encodeURIComponent(src)}`;
}

export function partnerSalesMailto(subject = 'EnterWeU EdTech partner plans') {
  return `mailto:${PARTNER_SALES_EMAIL}?subject=${encodeURIComponent(subject)}`;
}

const GO_PATH = /^\/api\/partners\/tutorials\/(\d+)\/go\/?$/;

/** Same-origin tracked tutorial link → { path, source }, else null. */
export function partnerGoTarget(href, origin = window.location.origin) {
  if (!href) return null;
  let url;
  try {
    url = new URL(href, origin);
  } catch {
    return null;
  }
  if (url.origin !== origin || !GO_PATH.test(url.pathname)) return null;
  return { path: url.pathname, source: url.searchParams.get('source') || 'partners_page' };
}

/**
 * Signed-in clicks on tracked tutorial links go through POST so the partner URL
 * carries the signed `enterweu_ref` used for course-completion score deltas.
 * The tab is opened synchronously so popup blockers allow it.
 */
export function installPartnerClickAttribution({
  doc = document,
  getToken = () => localStorage.getItem('access_token'),
  post,
  openWindow = (u) => window.open(u, '_blank'),
} = {}) {
  const onClick = (event) => {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const anchor = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    const target = anchor && partnerGoTarget(anchor.getAttribute('href'));
    if (!target || !getToken()) return;
    event.preventDefault();
    const win = openWindow('about:blank');
    if (win) win.opener = null;
    const go = (u) => {
      if (win) win.location.href = u;
      else window.location.href = u;
    };
    post(target.path, { source: target.source })
      .then((res) => go((res && res.data && res.data.url) || anchor.href))
      .catch(() => go(anchor.href));
  };
  doc.addEventListener('click', onClick, true);
  return () => doc.removeEventListener('click', onClick, true);
}
